import { Box, Container, Stack, Typography } from "@mui/material";
import { BackButton, BackDropLoading, Loading } from "@/organism";
import useDetail from "./useDetail";
import Subscription from "@/organism/Subscription";

export const Detail = () => {
  const { isLoading, subscriptionInfo, handleSubscriptionUpdate } = useDetail();

  if (!subscriptionInfo) {
    return <Loading />;
  }

  return (
    <Container maxWidth={"xl"}>
      <BackDropLoading isLoading={isLoading} />
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/subscription"}>구독 상품 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            구독 상품 상세 정보
          </Typography>
        </Stack>
      </Box>
      <Subscription.EditForm
        subscriptionInfo={subscriptionInfo}
        onEdit={handleSubscriptionUpdate}
      />
    </Container>
  );
};
